import styled, {keyframes} from 'styled-components';

const easeInOut = keyframes`
  0% {
    width: 40px;
  }
  50% {
    width: 110px;
  }
  75% {
    width: 175px;
  }
  100% {
    width: 200px;
  }
`;

const Wrapper = styled.div`
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
`;

const FakeLoaderWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 80%;
  height: 6px;
  background-color: #f6f6f8;
  margin: auto;
  margin-left: 10px;
  border-radius: 30px;
`;

const Svg = styled.div`
  position: absolute;
  left: 0;
  background-color: #47b881;
  width: 200px;
  height: 6px;
  display: block;
  top: 0;
  border-radius: 30px;
  x-transition: all 5s ease-in-out;
  animation: ${easeInOut} 5s 0.9;
`;

export const FakeProgressLine = () => {
  return (
    <Wrapper>
      <FakeLoaderWrapper>
        <Svg></Svg>
      </FakeLoaderWrapper>
    </Wrapper>
  );
};
